import { createModel } from '@rematch/core'
import * as firebase from 'firebase'
import { dispatch, store } from 'src/store'

interface IDiscussionState {
  chapterIdx: number
  insightId: string | null
  materialIdx: number
  replyId: string | null
  text: string
  isOpen: boolean
}

const initialState: IDiscussionState = {
  chapterIdx: -1,
  insightId: null,
  materialIdx: -1,
  replyId: null,
  text: '',
  isOpen: false
}

export default createModel({
  state: initialState,
  reducers: {
    updateState: (
      state: IDiscussionState,
      updated: Partial<IDiscussionState>
    ) => ({ ...state, ...updated }),
    changeCurrentReplyId: (
      state: IDiscussionState,
      { replyId }: { replyId: string | null }
    ) => ({ ...state, replyId, text: '' }),
    openDiscussion: (state: IDiscussionState) => ({ ...state, isOpen: true }),
    closeDiscussion: (state: IDiscussionState) => ({ ...state, isOpen: false })
  },
  effects: {
    async changeCurrentDiscussion({
      chapterIdx,
      insightId,
      materialIdx
    }: {
      chapterIdx: number
      insightId: string
      materialIdx: number
    }) {
      dispatch.discussion.updateState({
        isOpen: true,
        chapterIdx,
        insightId,
        materialIdx
      })
    },
    async addReply() {
      const currentUser = firebase.auth().currentUser
      const { discussion, lectureContent } = store.getState()
      if (discussion.replyId) {
        await dispatch.replies.addSubReply({
          lectureId: lectureContent.currentLectureId || '',
          chapterIdx: discussion.chapterIdx,
          insightId: discussion.insightId || '',
          materialIdx: discussion.materialIdx,
          replyId: discussion.replyId || '',
          subReply: {
            ts: firebase.firestore.Timestamp.now(),
            text: discussion.text,
            replierId: currentUser ? currentUser.uid : '',
            reactions: {
              like: []
            },
            revisions: []
          }
        })
      } else {
        await dispatch.insights.addReply({
          lectureId: lectureContent.currentLectureId || '',
          chapterIdx: discussion.chapterIdx,
          insightId: discussion.insightId || '',
          materialIdx: discussion.materialIdx,
          reply: {
            ts: firebase.firestore.Timestamp.now(),
            text: discussion.text,
            replierId: currentUser ? currentUser.uid : '',
            reactions: {
              like: []
            },
            revisions: []
          }
        })
      }
      dispatch.discussion.updateState({ text: '' })
    }
  }
})



// WEBPACK FOOTER //
// ./src/models/discussion.ts